const ALLOWED_MCN_ASSIGNMENT_PATTERN =
  /(^|\n)[ \t]*ALLOWED_MCN\s*[:=]\s*[^\s,\n}]+[ \t]*/gim;
const ALLOWED_MCN_QUOTED_KEY_PATTERN =
  /["']ALLOWED_MCN["']\s*:\s*["'][^"']*["']\s*,?/gim;

export const stripSensitiveChatText = (value: unknown): string => {
  if (typeof value !== 'string') {
    return '';
  }

  const sanitized = value
    .replace(ALLOWED_MCN_ASSIGNMENT_PATTERN, '$1')
    .replace(ALLOWED_MCN_QUOTED_KEY_PATTERN, '')
    .replace(/\n{3,}/g, '\n\n');

  return sanitized.trim();
};
